import React, {useState, useEffect, useRef} from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    CardContent,
    Button
} from '@material-ui/core';
import axios from '../../api';
import $ from 'jquery';
import 'datatables.net-dt/css/jquery.dataTables.css';
import 'datatables.net-dt/js/dataTables.dataTables.min.js';
import 'datatables.net/js/jquery.dataTables';
import Swal from "sweetalert2";
import VisualizarConsultorios from '../Actions/VisualizarConsultorios'
import EditarConsultorios from "../Actions/EditarConsultorios";
import ExcluirConsultorio from "../Actions/EcluirConsultorio";


const columns = [
    { id: 'id', label: 'Código', width: '15%' },
    { id: 'Consultório', label: 'Consultório', width: '40%' },
    { id: 'ativo', label: 'Disponível', width: '20%' },
    { id: 'acoes', label: 'Ações', width: '35%' },
];
function Tabela() {
    const [results, setTableData] = useState([]);
    const [onUpdate, setUpdated] = useState(false);
    const tableRef = useRef(null);

    function AtualizarTabela(id) {
        handleDelete(id)
    }


    const handleDelete = (id) => {
        const token = localStorage.getItem('token');

        axios.delete(`/consultorios?id=${id}`, {
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                // exibe mensagem de sucesso com cor verde
                Swal.fire({
                    icon: 'success',
                    title: 'Sucesso!',
                    text: response.data.message,
                });

                // Atualiza o estado de atualização da tabela
                setUpdated(!onUpdate);

                // Atualiza o estado da tabela removendo o item excluído
                setTableData(prevResults => prevResults.filter(result => result.id !== id));
            })
            .catch(error => {
                Swal.fire({
                    icon: 'error',
                    title: 'Erro!',
                    text: error.response.data.error,
                });
            });
    };


    useEffect(() => {

        Swal.fire({
            title: 'Carregando...',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        axios.get('/consultorios', {timeout: 5000})
            .then(response => {
                const results = response.data.data;
                setTableData(results);

                // Verifique se o DataTable já foi inicializado na tabela
                const table = $('#consultorios').DataTable();
                if ($.fn.DataTable.isDataTable('#consultorios')) {
                    table.destroy();
                }

                // Inicialize o DataTable aqui
                $(document).ready(function () {
                    $('#consultorios').DataTable({
                        language: {
                            url: '//cdn.datatables.net/plug-ins/1.10.25/i18n/Portuguese-Brasil.json'
                        },
                        deferRender: true,
                        destroy: true, // adicione essa opção
                        autoWidth: false,
                        columnDefs: [
                            {
                                targets: ['_all'],
                                className: 'mdc-data-table__cell',
                            },
                        ],
                    });
                });
            })
            .catch(error => {
                console.log(error);
            })
            .finally(() => {
                Swal.close();
            });
    }, [setTableData]);

    function fetchTableData() {
        const token = localStorage.getItem('token');
        axios.get('/consultorios', { headers: { Authorization: `Bearer ${token}` } })
            .then(response => {
                const results = response.data.data;
                setTableData(results);
                // Realizar alguma ação adicional, se necessário
                setUpdated(!onUpdate);
            })
            .catch(error => {
                console.log(error)
            });
    }


    useEffect(() => {
        if (tableRef.current) {
            $(tableRef.current).DataTable();
        }
    }, [setTableData]);


    const liberar = (id) => {
        Swal.fire({
            icon: 'question',
            title: 'Confirmação',
            text: 'Tem certeza de que deseja liberar o consultório?',
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não',
        }).then((result) => {
            if (result.isConfirmed) {
                axios
                    .put(`/consultorios/liberar/${id}`)
                    .then((response) => {
                        Swal.fire({
                            icon: 'success',
                            title: 'Sucesso',
                            text: 'Consultório liberado com sucesso.',
                        });
                        // Realizar alguma ação adicional, se necessário
                        fetchTableData();
                    })
                    .catch((error) => {
                        Swal.fire({
                            icon: 'error',
                            title: 'Erro',
                            text: 'Ocorreu um erro ao liberar o consultório.',
                        });
                    });
            }
        });
    };
    return (

        <TableContainer component={Paper}>
            <CardContent>
                <Table id="consultorios" className={'table is-striped'} ref={tableRef}>
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell id={"header"} style={{width: column.width}}
                                           key={column.id}>{column.label}</TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {results.map((result) => (
                            <TableRow key={result.id}>
                                <TableCell>{result.id}</TableCell>
                                <TableCell>{result.consultorio}</TableCell>
                                <TableCell style={{textAlign: 'center'}}>
                                    {(Number(result.ativo) === 1) ?
                                        <i className="fas fa-door-open"
                                           style={{color: 'green', fontSize: '25pt'}}></i> :
                                        <i className="fas fa-door-closed" style={{color: 'red', fontSize: '25pt'}}></i>
                                    }
                                </TableCell>
                                <TableCell>
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        margin: '2 auto',
                                        padding: 2
                                    }}>
                                        <Button variant="contained" id="info" size="small" onClick={() => liberar(result.id)}>
                                            <i className="fas fa-remove"></i> Liberar
                                        </Button>
                                        <VisualizarConsultorios id={Number(result.id)} title="Detalhes Consultório"
                                                                apiUrl={`https://gerenciamentoatendimento.cloud/api/consultorios/`}/>
                                        <EditarConsultorios id={Number(result.id)} title="Editar Consultório"
                                                            apiUrl={`https://gerenciamentoatendimento.cloud/api/consultorios/`}
                                                            fetchTableData={fetchTableData}
                                        />
                                        <ExcluirConsultorio id={Number(result.id)} title="Excluir Consultório"
                                                            apiUrl={`https://gerenciamentoatendimento.cloud/api/consultorios/`}
                                                           AtualizarTabela={AtualizarTabela}/>

                                    </div>

                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </CardContent>
        </TableContainer>

    );
}

export default Tabela;
